/**
 * Returns a random delay between 200ms and 1000ms
 * Used in the survey to make the questions appear to load
 */
export function getRandomDelay() {
  return Math.floor(Math.random() * (1000 - 200 + 1)) + 200;
}
